import { render, staticRenderFns } from "./goods_import_operate_detail.vue?vue&type=template&id=2dd33a22&scoped=true&"
import script from "./goods_import_operate_detail.vue?vue&type=script&lang=ts&"
export * from "./goods_import_operate_detail.vue?vue&type=script&lang=ts&"
import style0 from "./goods_import_operate_detail.vue?vue&type=style&index=0&id=2dd33a22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd33a22",
  null
  
)

export default component.exports